import CircleChart from './CircleChart';
import './CircleChart.scss';

export default CircleChart;